import { render, staticRenderFns } from "./ListProject.vue?vue&type=template&id=2e322f08&scoped=true&"
import script from "./ListProject.vue?vue&type=script&lang=js&"
export * from "./ListProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e322f08",
  null
  
)

export default component.exports